import { render } from "./CtaHabiente.vue?vue&type=template&id=47db6b3c&scoped=true"
import script from "./CtaHabiente.vue?vue&type=script&lang=js"
export * from "./CtaHabiente.vue?vue&type=script&lang=js"

import "./CtaHabiente.vue?vue&type=style&index=0&id=47db6b3c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47db6b3c"]])

export default __exports__